import React from 'react';

import SingleNextButton from '../Atoms/SingleNextButton';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import SelectField from '../Molecules/SelectField';
import { isActiveInAz } from '../../Utils/SelectOptions';

class StepProspectMemberEligibility extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        // Display Navigation bar
        document.querySelector('body').classList.add('hidden-header');
        
        return (
            <StepShell
                stepID="StepProspectMemberEligibility"
                friendlyText="Not a Vantage West member? No worries! Let's check your eligibility."
                requestText="Please read the following statement carefully so we can determine your Membership eligibility."
                progress="25%"
                progressLabel="Eligibility"
                backLink="/loan-application/"
            >

                <Form nextLink="/loan-application/identity">
                    <p>Membership is open to anyone who lives, works, worships, attends school or volunteers in these geographic areas.</p>
                    <ul>
                        <li>Pima, Pinal, Cochise, or Maricopa Counties</li>
                        <li>Gila River Indian Community Reservation</li>
                        <li>Arizona’s “Copper Basin” Area</li>
                    </ul>
                    <SelectField options={isActiveInAz} required={true} name="currentActiveAz" placeholder="Do you qualify for Membership?" labelType="hidden"
                    />
                    <SingleNextButton nextBtnTxt="next" />

                </Form>

            </StepShell>
        )
    }
}

export default StepProspectMemberEligibility;
